import { List, useDataGrid } from "@refinedev/mui";
import React from "react";
import { useDeleteMany } from "@refinedev/core";

import { GridRowSelectionModel } from "@mui/x-data-grid";
import { Button } from "@mui/material";

import { IExpense } from "./interfaces";
import { SearchToolbar, DataGridPanel, ListPageHeader } from "components/list";
import { expensesColumns } from "./components/expensesColumns";
import { expensesSearchFields } from "./components/expensesSearchFields";

export const ExpenseList: React.FC = () => {
    const { dataGridProps, setFilters, filters, tableQueryResult } =
        useDataGrid<IExpense>({
            initialCurrent: 1,
            initialPageSize: 20,
            sorters: {
                initial: [{ field: "id", order: "desc" }]
            }
        });

    const [rowSelectionModel, setRowSelectionModel] = React.useState<GridRowSelectionModel>([]);

    // refine의 rowCount는 fetch 중 잠깐 0으로 떨어져 "전체 0건"이 깜빡인다.
    // 로딩이 아닐 때의 마지막 값을 유지해 표시한다.
    const lastRowCountRef = React.useRef<number | undefined>(undefined);
    if (!dataGridProps.loading && typeof dataGridProps.rowCount === "number") {
        lastRowCountRef.current = dataGridProps.rowCount;
    }

    const { mutate } = useDeleteMany<IExpense>();

    // 선택된 행 일괄 삭제 (현행 로직 유지)
    const deleteSelectedItems = () => {
        mutate(
            {
                resource: "expenses",
                ids: rowSelectionModel.map((id) => id.toString())
            },
            {
                onSuccess: () => {
                    setRowSelectionModel([]);
                }
            }
        )
    }

    const hasSelected = rowSelectionModel.length > 0;

    return (
        <List
            breadcrumb={<></>}
            headerButtons={({ defaultButtons }) => (
                <>
                {defaultButtons}
                <Button
                    variant="contained"
                    color="primary"
                    onClick={deleteSelectedItems}
                    disabled={!hasSelected}
                >
                    선택 삭제하기
                </Button>
                </>
            )}
        >
            <ListPageHeader
                count={lastRowCountRef.current}
                description="현장요원이 제출한 방문 경비 내역"
            />

            <SearchToolbar
                fields={expensesSearchFields}
                filters={filters}
                setFilters={setFilters}
            />

            <DataGridPanel
                {...dataGridProps}
                columns={expensesColumns}
                getRowShowPath={(row) => `/expenses/show/${row.id}`}
                isError={tableQueryResult.isError}
                errorMessage="경비 목록을 불러오지 못했습니다."
                emptyMessage="조건에 맞는 경비 내역이 없습니다."
                pageSizeOptions={[10, 20, 30, 50, 100]}
                disableColumnFilter
                filterModel={undefined}
                checkboxSelection
                onRowSelectionModelChange={(model) => setRowSelectionModel(model)}
                rowSelectionModel={rowSelectionModel}
            />
        </List>
    );
};
